import { connect } from 'react-redux';

import RoleManager from './RoleManager.js';

const mapStateToProps = state => {
  return {
    productList: state.api.user.info.products,
  };
};

const ConnectedRoleManager = connect(
  mapStateToProps,
  null
)(RoleManager);

export default ConnectedRoleManager;
